import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import dayjs from "dayjs";
import { getChallengeStatus, normalizeStickers } from "./helpers";

const ChallengeViewModal = ({ open, onClose, viewDetails }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth // Ensures the dialog uses the full width of maxWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "80%",
          maxWidth: "400px",
        },
      }}
    >
      <DialogTitle
        style={{ fontSize: "20px", width: "200px", color: "black" }}
      >
        Challenge Details
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ fontSize: "18px" }}>
          Title:{" "}
          <span style={{ fontWeight: 400 }}>{viewDetails.title}</span>
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px" }}>
          Category:{" "}
          <span style={{ fontWeight: 400 }}>
            {viewDetails.category?.name || "N/A"}
          </span>
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px" }}>
          Start Date:
          <span style={{ fontWeight: 400 }}>
            {" "}
            {viewDetails.startDate
              ? dayjs(viewDetails.startDate).format("DD MMM YYYY - h:mm A")
              : "TBD"}
          </span>
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px" }}>
          End Date:{" "}
          <span style={{ fontWeight: 400 }}>
            {viewDetails.endDate
              ? dayjs(viewDetails.endDate).format("DD MMM YYYY - h:mm A")
              : "TBD"}
          </span>
        </Typography>

        {/* Show challenge status */}
        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
          <Typography
            variant="body1"
            sx={{ fontSize: "18px", marginRight: 1 }}
          >
            Status:{" "}
          </Typography>
          {(() => {
            const statusInfo = getChallengeStatus(
              viewDetails.startDate,
              viewDetails.endDate
            );
            return (
              <Chip
                label={statusInfo.status}
                size="medium"
                sx={{
                  backgroundColor: statusInfo.bgColor,
                  color:
                    statusInfo.color === "warning"
                      ? "#856404"
                      : statusInfo.color === "error"
                      ? "#721c24"
                      : statusInfo.color === "default"
                      ? "#41464b"
                      : "#0c5460",
                  fontWeight: "600",
                  fontSize: "14px",
                  height: "28px",
                }}
              />
            );
          })()}
        </Box>

        {/* Show category logo */}
        {viewDetails.category?.logo ? (
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography variant="body1" sx={{ fontSize: "18px" }}>
              Category Logo:&nbsp;
            </Typography>
            <img
              src={viewDetails.category.logo}
              alt="Category Logo"
              style={{
                maxWidth: "100px",
                maxHeight: "100px",
                objectFit: "contain",
              }}
            />
          </Box>
        ) : (
          <Typography variant="body1">No Category Logo</Typography>
        )}

        {viewDetails.backgroundImage ? (
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography variant="body1" sx={{ fontSize: "18px" }}>
              Background Image:&nbsp;
            </Typography>
            <img
              src={viewDetails.backgroundImage}
              alt="Challenge Background"
              style={{
                maxWidth: "200px",
                maxHeight: "120px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          </Box>
        ) : (
          <Typography variant="body1" sx={{ mt: 1 }}>
            No Background Image
          </Typography>
        )}

        {normalizeStickers(viewDetails).length ? (
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography variant="body1" sx={{ fontSize: "18px" }}>
              Stickers:&nbsp;
            </Typography>
            <Box sx={{ display: "flex", gap: "8px" }}>
              {normalizeStickers(viewDetails).map((sticker, index) => (
                <img
                  key={sticker.mediaId || sticker.url}
                  src={sticker.url}
                  alt={`Sticker ${index + 1}`}
                  style={{
                    width: "56px",
                    height: "56px",
                    objectFit: "contain",
                    borderRadius: "4px",
                    backgroundColor: "#f4f4f4",
                  }}
                />
              ))}
            </Box>
          </Box>
        ) : (
          <Typography variant="body1" sx={{ mt: 1 }}>
            No Stickers
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChallengeViewModal;
